import { twMerge } from "tailwind-merge";
import { themeLight, themeDark, themeSystem, Theme } from "../../constants";
import { ControlCenterButton } from "./ControlCenterButton";
import { Contrast01, Moon02, Sun } from "untitledui-js/react";
import { useTranslation } from "react-i18next";
import { useUpdatePreference } from "@hooks/useUpdatePreference";

interface ThemeSwitchProps {
  currentTheme: Theme;
  buttonVariant?: "light" | "dark";
  className?: string;
}

export const ThemeSwitch = ({ currentTheme, buttonVariant, className }: ThemeSwitchProps) => {
  const { mutate: updatePreferences } = useUpdatePreference();
  const { t } = useTranslation();

  const handleThemeSelection = (e: React.MouseEvent<HTMLButtonElement>) => {
    // get the id of the clicked button
    const theme = e.currentTarget.id as Theme;
    // Save the selected theme to the user preferences
    updatePreferences({
      themePreference: theme,
    });
  };

  return (
    <div className={twMerge("flex gap-2", className)}>
      <ControlCenterButton
        id={themeLight}
        icon={<Sun />}
        text={t("ControlCenter.light")}
        onClick={handleThemeSelection}
        active={currentTheme === themeLight}
        ariaLabel={t("ControlCenter.displayModeLight")}
        buttonVariant={buttonVariant}
      />
      <ControlCenterButton
        id={themeDark}
        icon={<Moon02 />}
        text={t("ControlCenter.dark")}
        onClick={handleThemeSelection}
        active={currentTheme === themeDark}
        ariaLabel={t("ControlCenter.displayModeDark")}
        buttonVariant={buttonVariant}
      />
      <ControlCenterButton
        id={themeSystem}
        icon={<Contrast01 />}
        text={t("ControlCenter.system")}
        onClick={handleThemeSelection}
        active={currentTheme === themeSystem}
        ariaLabel={t("ControlCenter.displayModeAutomatic")}
        buttonVariant={buttonVariant}
      />
    </div>
  );
};
